export default __webpack_public_path__ + "static/media/convite_emitido.a19dce16.svg";